import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardMessageFormatOption')(function discardMessageFormatOption(state) {
    var optionState = state.optionState;
    optionState.showBcc = null;
    optionState.showFrom = null;
    optionState.composeFormat = null;
    optionState.fontFamily = null;
    optionState.fontSize = null;
    optionState.isFontBold = null;
    optionState.isFontItalic = null;
    optionState.isFontUnderline = null;
    optionState.fontColor = null;
    optionState.isColorMenuShown = false;
}));
//# sourceMappingURL=discardMessageFormatOption.js.map